var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('div',{staticClass:"loading-bar-container"},[_c('div',{staticClass:"loading-bar"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }